import React from 'react';
import {Doughnut} from 'react-chartjs-2';
import {Chart as ChartJS, ArcElement, Tooltip, Legend} from 'chart.js';
import {Loader} from 'components';

ChartJS.register(ArcElement, Tooltip, Legend);

const AccountEventsChart = ({accountsTooltip, totalStatuses, loading}) => {
  const totalEvents =
    totalStatuses?.reduce((sum, status) => sum + status.count, 0) || 0;

  const allowedCount =
    totalStatuses?.find(s => s.final_outcome === 'ALLOW')?.count || 0;
  const pendingCount =
    totalStatuses?.find(s => s.final_outcome === 'PENDING')?.count || 0;
  const blockedCount =
    totalStatuses?.find(s => s.final_outcome === 'BLOCK')?.count || 0;

  const allowedPercentage =
    totalEvents > 0 ? Math.round((allowedCount / totalEvents) * 100) : 0;
  const pendingPercentage =
    totalEvents > 0 ? Math.round((pendingCount / totalEvents) * 100) : 0;
  const blockedPercentage =
    totalEvents > 0 ? Math.round((blockedCount / totalEvents) * 100) : 0;

  const data = {
    labels: ['Allowed', 'Pending', 'Blocked'],
    datasets: [
      {
        data: [allowedCount, pendingCount, blockedCount],
        backgroundColor: ['#55A249', '#DC6803', '#B42318'],
        borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF'],
        borderWidth: 5,
        borderRadius: 30,
        spacing: 5,
        rotation: -90,
        circumference: 360,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '75%',
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },
    hover: {
      mode: null,
    },
    events: [],
  };

  return (
    <div className="bg-white shadow-cards w-full h-full rounded-xl border-[0.5px] border-[#EFEFEF]">
      <div className="bg-[#F9F9F9] flex items-center justify-between py-3 px-6 rounded-t-xl">
        <p className="font-medium text-sm xl:text-base text-deepBlue">
          Account Events
        </p>
        <button>
          <img src={accountsTooltip} alt="Info" />
        </button>
      </div>

      {loading ? (
        <Loader height={20} />
      ) : (
        <>
          <div className="w-full justify-center items-center flex">
            <div
              className="flex justify-center relative"
              style={{width: 233, height: 233}}
            >
              <Doughnut data={data} options={options} />
              <div className="flex flex-col gap-1 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center">
                <h1 className="text-[24px] font-medium text-black">
                  {totalEvents.toLocaleString()}
                </h1>
                <p className="text-[#878787] text-sm   font-medium">
                  Total events
                </p>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center gap-4 mt-4 m-auto max-w-[300px] flex-wrap">
            <div className="flex items-center">
              <div className="w-4 h-4 rounded-full bg-[#55A249] mr-2"></div>
              <span className="text-[#4F555F] text-[12px]">Allowed</span>
              <span className="text-[#B7BBC3] text-[12px] ml-2">
                ({allowedPercentage}%)
              </span>
            </div>
            <div className="flex items-center">
              <div className="w-4 h-4 rounded-full bg-[#DC6803] mr-2"></div>
              <span className="text-[#4F555F] text-[12px]">Pending</span>
              <span className="text-[#B7BBC3] text-[12px] ml-2">
                ({pendingPercentage}%)
              </span>
            </div>
            <div className="flex items-center">
              <div className="w-4 h-4 rounded-full bg-[#B42318] mr-2"></div>
              <span className="text-[#4F555F] text-[12px]">Blocked</span>
              <span className="text-[#B7BBC3] text-[12px] ml-2">
                ({blockedPercentage}%)
              </span>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AccountEventsChart;
